(function () {
  const addOn = document.querySelector('[data-chain-add-on]');
  if (!addOn) return;

  const container = addOn.closest('.product__info-container') || document;
  const groups = {
    silver: addOn.querySelector('[data-chain-group="silver"]'),
    gold: addOn.querySelector('[data-chain-group="gold"]')
  };
  let lastMetal;

  function selectedMetal() {
    const picker = container.querySelector('variant-radios, variant-selects');
    if (!picker) return null;
    const chosen = [];
    picker
      .querySelectorAll('input[type="radio"]:checked, select')
      .forEach((el) => chosen.push((el.value || '').toLowerCase()));
    const joined = chosen.join(' ');
    if (joined.includes('silver')) return 'silver';
    if (joined.includes('gold')) return 'gold';
    return null;
  }

  function syncMetal() {
    const metal = selectedMetal();
    let shown = null;

    Object.keys(groups).forEach((key) => {
      const group = groups[key];
      if (!group) return;
      const active = key === metal;
      group.hidden = !active;
      group.querySelectorAll('input').forEach((input) => {
        input.disabled = !active || input.hasAttribute('data-unavailable');
      });
      if (active) shown = group;
    });

    if (!shown) { addOn.hidden = true; lastMetal = metal; return; }

    // only surface the block if this metal actually has a purchasable chain
    const available = shown.querySelector('input[value]:not([value=""]):not([data-unavailable])');
    addOn.hidden = !available;

    // reset to "No chain" only when the metal genuinely changed
    if (metal !== lastMetal) {
      const none = shown.querySelector('input[value=""]');
      if (none) none.checked = true;
    }
    lastMetal = metal;
  }

  // add charm + matching chain together — delegated so it survives form re-renders
  container.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const choice = addOn.querySelector('input[name="chain-option"]:checked:not([disabled])');
    const chainId = choice && choice.value;
    if (!chainId) return; // no chain → let the theme add the charm normally

    e.preventDefault();
    e.stopImmediatePropagation();

    const charmId = form.querySelector('[name="id"]').value;
    const qtyEl = form.querySelector('[name="quantity"]');
    const qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    const bundle = 'chain-' + Date.now();

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(charmId), quantity: qty, properties: { _chain_bundle: bundle } },
          { id: Number(chainId), quantity: qty, properties: { _chain_bundle: bundle } }
        ],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (!res.ok) { console.error('Chain add failed', data); return; }

    // hand off to the theme's own drawer renderer — it already knows how to
    // swap #CartDrawer / cart-icon-bubble correctly and calls open() for us
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
    } else if (cartDrawer) {
      // fallback, shouldn't normally be hit
      cartDrawer.classList.add('active', 'animate');
    }
  }, true);

  // keep the chain options matched to the charm's selected metal
  container.addEventListener('change', (e) => {
    if (e.target.closest('variant-radios, variant-selects')) syncMetal();
  });

  syncMetal();
})();